import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import PageHeading from "../../organisms/pageHeading/pageHeading";
import HeaderProgressBar from "../../atoms/headerProgressBar/headerProgressBar";
import NavigationButton from "../../atoms/button/navigationButton";
import {IconSource} from "../../../shared/enums/iconSource";
import "./transactionsListHeader.sass";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../stores/useStores";
import ButtonIcon from "../../atoms/button/buttonIcon";
import ExportTransactionsModal from "../../organisms/exportTransactionsModal/exportTransactionsModal";
import Tag from "../../atoms/tag/tag";
import {DateObservable} from "../../../stores/observables/dateObservable";
import {runInAction} from "mobx";

export interface ITransactionsListHeaderProps {}

const TransactionsListHeader: React.FC<ITransactionsListHeaderProps> = () => {
  const {t} = useTranslation(["translation", "notice", "event"]);
  const {
    uiStore: {transactionsUiStore}
  } = useStores();

  const monthYear = `${transactionsUiStore.selectedDate.toLocaleString(
    "en-us",
    {
      month: "long"
    }
  )} ${transactionsUiStore.selectedDate.getFullYear()}`;
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [selectedDate] = useState<DateObservable>(new DateObservable());

  const getTagType = () => {
    if (transactionsUiStore.transactions.totalCount > 0) {
      if (transactionsUiStore.transactions.isSuccess) {
        return "success";
      }
      return "negative";
    }

    return "neutral";
  };

  return (
    <div>
      <PageHeading title={t("translation:titles.transactions")} />
      <HeaderProgressBar
        progressBarLoading={transactionsUiStore.isLoadingTransactions}
      />
      <div className="transactions-list-header">
        <div>
          <NavigationButton
            icon={IconSource.leftArrow}
            tooltip={t("event:labels.calendar.previous")}
            onClick={() => transactionsUiStore.changeSelectedMonthTo(-1)}
          />

          <NavigationButton
            icon={IconSource.rightArrow}
            tooltip={t("event:labels.calendar.next")}
            onClick={() => transactionsUiStore.changeSelectedMonthTo(1)}
          />

          <div>{monthYear}</div>
          {transactionsUiStore.isLoadingTransactions ? null : (
            <>
              <div className="total-cost-transactions">
                <span className="dollar-symbol">$</span>
                {transactionsUiStore.transactions.totalPrice}
              </div>
              <Tag
                type={getTagType()}
                text={transactionsUiStore.transactions.totalCount.toString()}
              />
            </>
          )}
        </div>
        <ButtonIcon
          type="secondary"
          icon={IconSource.export}
          onClick={() => setIsExportModalOpen(true)}
        >
          {t("translation:actions.export")}
        </ButtonIcon>
      </div>
      <ExportTransactionsModal
        isOpen={isExportModalOpen}
        toggle={() => {
          setIsExportModalOpen(false);
          runInAction(() => {
            selectedDate.date = null;
          });
        }}
        selectedDate={selectedDate}
      />
    </div>
  );
};

export default observer(TransactionsListHeader);
